/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

export const onInitialClientRender = () => {
  const redirectHostnames = ["smhamza.com", "www.smhamza.com"]
  const targetHost = "https://smhamza.framer.website"
  const currentHost = window.location.hostname.toLowerCase()
  const currentPath = window.location.pathname.replace(/\/+$/, "") || "/"
  const isSeamossPage =
    currentHost === "www.smhamza.com" && currentPath === "/seamoss_ecommerce"

  if (redirectHostnames.includes(currentHost) && !isSeamossPage) {
    const path = window.location.pathname || "/"
    const search = window.location.search || ""
    const hash = window.location.hash || ""

    window.location.replace(`${targetHost}${path}${search}${hash}`)
    return
  }

  setTimeout(function () {
    const loader = document.getElementById("___loader")

    if (loader) {
      loader.style.display = "none"
    }
  }, 1000)
}
